import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={styles.leftSection}>
          <button 
            className={styles.menuToggle} 
            onClick={toggleMenu}
            aria-label="Menu"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 2.75A.75.75 0 011.75 2h12.5a.75.75 0 110 1.5H1.75A.75.75 0 011 2.75zm0 5A.75.75 0 011.75 7h12.5a.75.75 0 110 1.5H1.75A.75.75 0 011 7.75zM1.75 12a.75.75 0 100 1.5h12.5a.75.75 0 100-1.5H1.75z"/>
            </svg>
          </button>
          
          <Link to="/" className={styles.logo}>
            <span className={styles.logoText}>Be.dev</span>
          </Link>

          <nav className={`${styles.desktopNav}`}>
            <ul className={styles.navList}>
              <li className={styles.navItem}>
                <button className={styles.navButton}>
                  Produtos
                  <svg className={styles.chevron} width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                    <path d="M4.5 3L8.5 6L4.5 9" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                  </svg>
                </button>
                <div className={styles.dropdown}>
                  <div className={styles.dropdownContent}>
                    <div className={styles.dropdownSection}>
                      <h3 className={styles.dropdownTitle}>Sites & Aplicações</h3>
                      <ul className={styles.dropdownList}>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Sites Corporativos" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Sites Corporativos</strong>
                              <span>Presença digital profissional</span>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Sistemas Web" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Sistemas Web</strong>
                              <span>Aplicações personalizadas</span>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre APIs e Integrações" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>APIs & Integrações</strong>
                              <span>Conecte seus sistemas</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className={styles.dropdownSection}>
                      <h3 className={styles.dropdownTitle}>E-commerce & Mobile</h3>
                      <ul className={styles.dropdownList}>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Lojas Virtuais e E-commerce" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Lojas Virtuais</strong>
                              <span>Plataformas de vendas online</span>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Aplicativos Mobile" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Apps Mobile</strong>
                              <span>iOS e Android nativos</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
              <li className={styles.navItem}>
                <button className={styles.navButton}>
                  Soluções
                  <svg className={styles.chevron} width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                    <path d="M4.5 3L8.5 6L4.5 9" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                  </svg>
                </button>
                <div className={styles.dropdown}>
                  <div className={styles.dropdownContent}>
                    <div className={styles.dropdownSection}>
                      <h3 className={styles.dropdownTitle}>Desenvolvimento</h3>
                      <ul className={styles.dropdownList}>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Desenvolvimento Web" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Desenvolvimento Web</strong>
                              <span>Sites e aplicações web modernas</span>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Desenvolvimento Mobile" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Desenvolvimento Mobile</strong>
                              <span>Apps iOS e Android nativos</span>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre soluções de E-commerce" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>E-commerce</strong>
                              <span>Lojas virtuais completas</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className={styles.dropdownSection}>
                      <h3 className={styles.dropdownTitle}>Suporte</h3>
                      <ul className={styles.dropdownList}>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Suporte Técnico" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Suporte Técnico</strong>
                              <span>Manutenção e correções</span>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Consultoria" target="_blank" rel="noopener noreferrer" className={styles.dropdownItem}>
                            <div className={styles.dropdownItemContent}>
                              <strong>Consultoria</strong>
                              <span>Estratégia digital</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
              <li className={styles.navItem}>
                <button className={styles.navButton}>
                  Clientes
                  <svg className={styles.chevron} width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                    <path d="M4.5 3L8.5 6L4.5 9" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                  </svg>
                </button>
              </li>
              {/* <li className={styles.navItem}>
                <Link to="/bedev-play" className={`${styles.navButton} ${styles.playButton}`}>
                  Be.dev Play
                  <svg className={styles.playIcon} width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5V19L19 12L8 5Z"/>
                  </svg>
                </Link>
              </li> */}
            </ul>
          </nav>
        </div>


        <div className={styles.rightSection}>
          <a
            href="https://app.bedev.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.restrictedAccess}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <span>Acesso</span>
          </a>
        </div>
      </div>

      {/* Mobile menu */}
      <nav className={`${styles.mobileMenu} ${isMenuOpen ? styles.mobileMenuOpen : ''}`}>
        <ul className={styles.mobileNavList}>
          <li className={styles.mobileNavItem}>
            <a href="/" className={styles.mobileNavLink}>Home</a>
          </li>
          
          <li className={styles.mobileNavCategory}>
            <span className={styles.mobileCategoryTitle}>Produtos</span>
            <ul className={styles.mobileSubList}>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Sites Corporativos" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Sites Corporativos
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Sistemas Web" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Sistemas Web
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre APIs e Integrações" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  APIs & Integrações
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Lojas Virtuais e E-commerce" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Lojas Virtuais
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Aplicativos Mobile" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Apps Mobile
                </a>
              </li>
            </ul>
          </li>
          
          <li className={styles.mobileNavCategory}>
            <span className={styles.mobileCategoryTitle}>Soluções</span>
            <ul className={styles.mobileSubList}>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Desenvolvimento Web" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Desenvolvimento Web
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Desenvolvimento Mobile" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Desenvolvimento Mobile
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre soluções de E-commerce" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  E-commerce
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Suporte Técnico" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Suporte Técnico
                </a>
              </li>
              <li>
                <a href="https://wa.me/5521974561726?text=Olá! Gostaria de saber mais sobre Consultoria" 
                   target="_blank" rel="noopener noreferrer" className={styles.mobileSubLink}>
                  Consultoria
                </a>
              </li>
            </ul>
          </li>
          
          <li className={styles.mobileNavItem}>
            <a href="https://wa.me/5521974561726?text=Olá! Gostaria de conhecer os clientes da BeDev" 
               target="_blank" rel="noopener noreferrer" className={styles.mobileNavLink}>
              Clientes
            </a>
          </li>
          
          <li className={styles.mobileNavItem}>
            <a href="https://app.bedev.com.br/"
               target="_blank" rel="noopener noreferrer"
               className={`${styles.mobileNavLink} ${styles.mobileRestrictedButton}`}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              Acesso
            </a>
          </li>

        </ul>
      </nav>
    </header>
  );
};

export default Header;